export default __webpack_public_path__ + "static/media/excel_doc.f271199d.svg";